// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"b79c2058","506":"5b748c01","787":"9bd820c7"}[chunkId] + ".chunk.js";
};